import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppKeycloakService } from '../../services/keycloak.service';
// import { AppKeycloakService } from 'src/app/services/keycloak.service';
// import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'ngx-keycloak',
  templateUrl: './keycloak.component.html',
  styleUrls: ['./keycloak.component.scss']
})
export class KeycloakComponent implements OnInit
{

  constructor(private kk:AppKeycloakService){
    this.kk.spinLoading('none')
  }

   getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  getAllCookies(): { [key: string]: string } {
  const cookies: { [key: string]: string } = {};
  const cookieString = document.cookie;

  if (cookieString) {
    cookieString.split(';').forEach(cookie => {
      const [name, value] = cookie.split('=');
      cookies[name.trim()] = decodeURIComponent(value);
    });
  }

  return cookies;
}

getAllLocalStorage(): { [key: string]: string } {
  const data: { [key: string]: string } = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      data[key] = localStorage.getItem(key) || '';
    }
  }
  return data;
}

getAllSessionStorage(): { [key: string]: string } {
  const data: { [key: string]: string } = {};
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key) {
      data[key] = sessionStorage.getItem(key) || '';
    }
  }
  return data;
}


  ngOnInit(): void {
    let ls:any = this.getAllLocalStorage()
    console.log(ls)
    
  }

  redirectToRegister() {
    const redirectUri = encodeURIComponent('http://localhost:4200');
    const url = `https://auth.suryojasvi.com/auth/realms/wyzminds/protocol/openid-connect/registrations?client_id=wyzminds-auth&response_type=code&scope=openid&redirect_uri=${redirectUri}`;
    window.location.href = url;
  }

  keycloakInit(){
    console.log("keycloak ==>>> ");
    this.kk.init()
     .then((authenticated:any) => {
      console.log('User is authenticated:', authenticated);
      return authenticated;
    }).catch((e) => {
      console.error('Keycloak initialization failed => ', e);
      return false;
    });
    // .then((r)=>{
    //   console.log("response => ",r)
    // })
    console.log(this.getAllCookies())
  }

  login(){
    console.log("KeycloakService => ", this.kk)
    this.kk.init()
     .then(authenticated => {
      console.log("Keycloak initialized:", authenticated, "this.kc => ", this.kk);
    })
    .catch(err => {
      console.error("Keycloak init failed", err);
    });
  
    
  }

   getToken() {
    // this.kk.init()
    //  .then((authenticated:any) => {
    //   console.log('User is authenticated:', authenticated);
    //   return authenticated;
    // }).catch((e) => {
    //   console.error('Keycloak initialization failed => ', e);
    //   return false;
    // });
    console.log("this.kk => ",this.kk)
    console.log(this.kk.getToken())
  }

  getUsername() {
   console.log(this.kk.getUsername()) 
  }

  logout(){
   console.log(this.kk.logout())
  }
}
